import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxNoticeDialogComponent } from './components/notice-dialog/notice-dialog.component';
import { NgxNoticeInfoSnackbarComponent } from './components/notice-info-snackbar/notice-info-snackbar.component';
import { NgxNoticeInlineComponent } from './components/notice-inline/notice-inline.component';
import { NotofierService } from './notofier.service';
import { NotofierLegacyService } from './services/notofier-legacy.service';
import { NotofierStrategyService } from './services/notofier-strategy.service';
import { NotofierTemplatingService } from './services/notofier-templating.service';
import { NotofierUtilitiesService } from './services/notofier-utilities.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatSnackBarModule,
        MatIconModule,
        OverlayModule
    ],
    declarations: [ NgxNoticeDialogComponent, NgxNoticeInfoSnackbarComponent, NgxNoticeInlineComponent ],
    providers: [
        NotofierService,
        OverlayModule,
        NotofierLegacyService,
        NotofierStrategyService,
        NotofierTemplatingService,
        NotofierUtilitiesService
    ]
})
export class NotofierModule {
    static forRoot (): ModuleWithProviders<NotofierModule> {
        return {
            ngModule: NotofierModule,
            providers: [ { provide: 'NOTIFICATION_SERVICE', useClass: NotofierService } ]
        };
    }
}
